<template>
  <div>
    <h3 class="m-0 bg-cal-green text-white text-lg px-4 py-2 mb-2">{{ headline }}</h3>
    <fieldset class="border-0 m-0 p-4">
      <legend class="text-cal-light-blue font-bold p-0 m-0 uppercase text-base">{{ title }}</legend>
      <slot></slot>
    </fieldset>
  </div>
</template>
<script>
export default {
  props: {
    headline: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  }
}
</script>
